import React from 'react';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import Late2023MemberNavImpl from './Late2023MemberNavContainer';

export default function MyMeetingsPicker(props) {
  useScrollTopOnMount();
  return <Late2023MemberNavImpl {...props} />;
}
